<template>  
    
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.UBN') }}</h5>
        <p class="text-sm">{{ $t('common.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('mating.UBN') }} *</label>
                <select id="ubnId" v-model="state.ubnId" class="form-control form-control-default" disabled>
                    <option value="">{{ $t('mating.Select_UBN') }}</option>
                    <option v-for="item in state.ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="vrulesUBN$.ubnId.$error" class="text-sm text-danger">
                    {{ vrulesUBN$.ubnId.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('mating.Male_leased') }}</label>
                <div class="d-block mt-1">
                  <material-switch v-model="state.maleLeased" id="maleLeased" name="maleLeased" disabled />
                </div>
              </div>            
            </div>
        </div>        
        <!--div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('mating.Update_UBN') }}</button>
        </div-->
      </div>
    </div>
    <div id="male" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.Male') }}</h5>
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased && selectedLeaseUBN">{{ $t('mating.Male_leased_from_UBN') }} {{ selectedLeaseUBN }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('mating.Selected_male') }} ({{ selectedMales.length }})</p>
              <div class="row">
                <div v-for="male in selectedMales" :key="male.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light" @click="toggleSelect(male)">
                    {{ displayText(male) }}
                    <span 
                      class="text-danger position-absolute top-1 end-0"
                      style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                      @click.stop="toggleSelect(male)"
                    >
                      ×
                    </span>
                  </div>
                </div>
                <p class="text-danger text-sm" v-if="selectedMales.length === 0" style="margin-bottom: 2px !important;">
                  {{ $t('common.No_male_selected') }}
                </p>
                <p class="text-danger text-sm" v-if="vrulesMales$.selectedMaleId.$error">
                  {{ vrulesMales$.selectedMaleId.$errors[0].$message }}
                </p>                
              </div>
            </div>
          </div>
          <div class="col-6">
            <!-- Search Input -->
            <div class="input-group input-group-static null">
              <label class="">{{ $t('mating.Search') }}</label>
              <input v-model="state.searchQueryMale" type="text" class="form-control form-control-default" :placeholder="$t('mating.Search_UBN_studbooknumber_animalnumber_name')"> 
            </div>
          </div>
          <div class="col-12 mt-3">
            <!-- Available Males -->
            <p class="fw-bold text-sm">{{ $t('mating.Available_males') }}</p>
            <div class="row">
              <div v-for="male in filteredMales" :key="male.id" class="col-md-6 mb-1">
                <div class="card border text-sm" :class="{ 'border-success bg-light': isSelected(male.id), 'cursor-pointer': true }" @click="toggleSelect(male)">
                  {{ displayText(male) }}
                </div>
              </div>
            </div>
          </div>
        </div>      
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateMale" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('mating.Update_male') }}</button>
        </div>
      </div>
    </div>
    <div id="female" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('mating.Female') }}</h5>
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased && selectedLeaseUBN">{{ $t('mating.Male_leased_from_UBN') }} {{ selectedLeaseUBN }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('mating.Selected_females') }} ({{ selectedFemales.length }})</p>
              <div class="row">
                <div v-for="female in selectedFemales" :key="female.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light" @click="toggleSelectFemale(female)">
                    {{ displayText(female) }}
                    <span 
                      class="text-danger position-absolute top-1 end-0"
                      style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                      @click.stop="toggleSelectFemale(female)"
                    >
                      ×
                    </span>
                  </div>
                </div>
                <p class="text-danger text-sm" v-if="selectedFemales.length === 0" style="margin-bottom: 2px !important;">
                  {{ $t('common.No_female_selected') }}
                </p>
                <p class="text-danger text-sm" v-if="vrulesFemales$.selectedFemaleIds.$error">
                  {{ vrulesFemales$.selectedFemaleIds.$errors[0].$message }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-6">
            <!-- Search Input -->
            <div class="input-group input-group-static null">
              <label class="">{{ $t('mating.Search') }}</label>
              <input v-model="state.searchQueryFemale" type="text" class="form-control form-control-default" :placeholder="$t('mating.Search_UBN_studbooknumber_animalnumber_name')"> 
            </div>
          </div>
          <div class="col-12 mt-3">
            <!-- Available Females -->
            <p class="fw-bold text-sm">{{ $t('mating.Available_females') }}</p>
            <div class="row">
              <div v-for="female in filteredFemales" :key="female.id" class="col-md-6 mb-1">
                <div class="card border text-sm" :class="{ 'border-success bg-light': isSelected(female.id), 'cursor-pointer': true }" @click="toggleSelectFemale(female)">
                  {{ displayText(female) }}
                </div>
              </div>
            </div>
          </div>         
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateFemale" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('mating.Update_female') }}</button>
        </div>
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.Date') }}</h5>           
        <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
        <p class="mb-0 text-sm text-green" v-if="state.maleLeased && selectedLeaseUBN">{{ $t('mating.Male_leased_from_UBN') }} {{ selectedLeaseUBN }}</p>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_from') }} *</label>
                  <input v-model="state.dateFrom" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('mating.Date_from')">
                  <span v-if="vrulesDates$.dateFrom.$error" class="text-sm text-danger">
                      {{ vrulesDates$.dateFrom.$errors[0].$message }}
                  </span>
              </div>
          </div>
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_to') }}</label>
                  <input v-model="state.dateTo" type="date" class="form-control form-control-default" :placeholder="$t('mating.Date_to')">
                  <span v-if="vrulesDates$.dateTo.$error" class="text-sm text-danger">
                    {{ vrulesDates$.dateTo.$errors[0].$message }}
                  </span>
              </div>
          </div>
        </div> 
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateDate" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('mating.Update_date') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteMating" name="Delete" v-model="state.deleteMating"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteMating" @click="deleteMating" name="button">{{ $t('mating.Delete_mating') }}</button>
      </div>
    </div>    
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed, nextTick, ref } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import Choices from 'choices.js';


  export default {
    name: "MatingDetailItem",
    setup() {
        
      const { t } = useI18n()
      const todayDate = new Date().toISOString().split('T')[0];
      const state = reactive ({        
        gets: [],

        id: '',
        type: '',
        associationId: '',
        ubnId: '',
        maleLeased: false,
        selectedLeaseUBN: '',
        maleLeasedFromUBNId: '',
        maleId: '',
        femaleIds: '',
        dateFrom: null,
        dateTo: null,

        ubns:[],
        males:[],
        females:[],

        deleteMating: false,

        selectedMaleId: '',
        selectedMaleLeasedFromUBNId: '',
        searchQueryMale: '',

        selectedFemaleIds: [],
        searchQueryFemale: ''
    })

    const dateToAfterOrEqualDateFrom = helpers.withMessage(
      t('common.Date_to_must_be_greater_than_or_equal_to_Date_from'),
      (value, vm) => {          
          console.log("Validator triggered: from", vm.dateFrom, "to", value)
          if (!value || !vm.dateFrom) return true

          const from = new Date(vm.dateFrom)
          const to = new Date(value)

          return !isNaN(to) && !isNaN(from) && to >= from
      }
      //(value, vm) => {
//        if (!vm || !vm.state) return true; // Guard against null
  //      if (!value || !vm.state.dateFrom) return true;

    //    const dateTo = new Date(value);
      //  const dateFrom = new Date(vm.state.dateFrom);

        //if (isNaN(dateTo.getTime()) || isNaN(dateFrom.getTime())) return false;

        //return dateTo >= dateFrom;
      //}
    );
    
    const rulesUBN = computed(() => ({
      ubnId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('common.Select_a_ubn'), value => value !== '')
      }
    }))
    
    const isSelected = (id) => state.selectedMaleId === id;

    const toggleSelect = (male) => {
      const isAlreadySelected = state.selectedMaleId === male.id;

      // If already selected, unselect it
      if (isAlreadySelected) {
        state.selectedMaleId = '';
        state.selectedMaleLeasedFromUBNId = '';
      } else {
        state.selectedMaleId = male.id;
        state.selectedMaleLeasedFromUBNId = male.ubnId;
      }
    }

    const displayText = (f) =>             
      `${f.ubn} ${f.studbookNumber ? ` | ${f.studbookNumber}` : ''}${f.animalNumber ? ` | ${f.animalNumber}` : ''}${f.name ? ` (${f.name})` : ''} ${f.inbreedFactor != ' ' ? ` | ${f.inbreedFactor}` : ''}${f.breedCode ? ` | ${f.breedCode}` : ''}`

    const selectedMales = computed(() =>
      state.males.filter(f => f.id === state.selectedMaleId)
    )

    const filteredMales = computed(() => {
      const query = state.searchQueryMale?.toLowerCase() || '';
      return state.males.filter((male) => {
        const text = displayText(male)?.toLowerCase() || '';
        return state.selectedMaleId !== male.id && text.includes(query);
      });
    });
    
    const selectedLeaseUBN = computed(() => {
      return selectedMales.value.length > 0 ? selectedMales.value[0]?.ubn || '' : ''
    })
    
    const selectedFemaleIds = ref(
      String(state.femaleIds || '').split(',').filter(id => id)
    )

    const isSelectedFemale = (id) => selectedFemaleIds.value.includes(id)

    const toggleSelectFemale = (female) => {
      const index = state.selectedFemaleIds.indexOf(female.id)
      if (index > -1) {
        state.selectedFemaleIds.splice(index, 1)
      } else {
        state.selectedFemaleIds.push(female.id)
      }
    }
    
    const selectedFemales = computed(() =>
      state.females.filter(f => state.selectedFemaleIds.includes(f.id))
    )

    const filteredFemales = computed(() =>
      state.females.filter(f =>
        !state.selectedFemaleIds.includes(f.id) &&
        displayText(f).toLowerCase().includes(state.searchQueryFemale.toLowerCase())
      )
    )

    const rulesMales = computed(() => ({
      selectedMaleId: {
        required: helpers.withMessage(t('common.Select_one_male'), value => !!value)
      }      
    }))

    const rulesFemales = computed(() => ({
      selectedFemaleIds: {
          required: helpers.withMessage(t('common.Select_at_least_one_female'), required),
          minOne: helpers.withMessage(t('common.Select_at_least_one_female'), value => value.length > 0)
        }
    }))

    const rulesDates = computed(() => {
        return {
            dateFrom: { required: helpers.withMessage(t('common.Required'), required) },
            dateTo: { dateToAfterOrEqualDateFrom }
        }
    })
    
    const vrulesUBN$ = useVuelidate(rulesUBN, state)
    const vrulesMales$ = useVuelidate(rulesMales, state)
    const vrulesFemales$ = useVuelidate(rulesFemales, state)
    const vrulesDates$ = useVuelidate(rulesDates, state)

    return {
        state,
        isSelected,
        isSelectedFemale,
        toggleSelect,
        toggleSelectFemale,
        displayText,
        selectedMales,
        filteredMales,
        selectedFemales,
        filteredFemales,
        selectedLeaseUBN,        
        vrulesUBN$,
        vrulesMales$,
        vrulesFemales$,
        vrulesDates$,
        todayDate
      }
  },    
  components: {      
    MaterialSwitch,
  },  
  async mounted() {  
      this.id = this.$route.params.id;
      this.type = this.$route.params.type; // Can be group or single
      
      try {
            this.$store.commit('setShowLoading', true);
            await this.loadAll();

            console.log('From:', this.state.dateFrom);
            console.log('To:', this.state.dateTo);
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {        
      async loadAll() {
        await this.fetchMatingData(this.id);
        await this.fetchAllUBN();
        await this.fetchAllMale();
        await this.fetchAllFemale();
      },
      async fetchMatingData(groupGuid) {
        try {
            const response = await axios.get(`mating/group/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.mating = this.gets.data;

                this.state.associationId = this.state.mating.associationId;
                this.state.id = this.state.mating.id;
                this.state.groupGuid = this.state.mating.groupGuid;
                this.state.ubnId = this.state.mating.ubnid;
                this.state.maleId = this.state.mating.maleId;
                this.state.femaleIds = this.state.mating.femaleIds;
                this.state.dateFrom = this.state.mating.dateFrom;
                this.state.dateTo = this.state.mating.dateTo;
                this.state.maleLeasedFromUBNId = this.state.mating.maleLeasedFromUBNId;
                this.state.maleLeased = this.state.mating.maleLeased;

                this.state.selectedMaleId = this.state.mating.maleId;
                this.state.selectedFemaleIds = this.state.mating.femaleIds
                                              ? this.state.mating.femaleIds.split(',').map(id => id.trim())
                                              : [];

            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      async fetchAllUBN()
      {
          try { 
              const response = await axios.get("Location/getallbyassociation", {
                  params: {
                      associationId: this.state.associationId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data.locationList)) {
                  this.state.ubns = result.data.locationList;

                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "ubnId",
                      dataList: this.state.ubns,
                      selectedValue: this.state.ubnId,
                      instanceKey: "choicesInstanceUBN"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_ubns');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllMale() 
      {
          try { 
              const response = await axios.get("Animal/getallmale", {
                  params: {
                      associationId: this.state.associationId,
                      animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                      ubnId: this.state.ubnId,
                      maleLeased: this.state.maleLeased
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  this.state.males = result.data;
              } else {    
                  this.$showSuccess('errors.Error_fetching_males');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllFemale() 
      {
          try { 
              const response = await axios.get("Animal/getallfemale", {
                  params: {
                      associationId: this.state.associationId,                        
                      animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                      ubnId: this.state.ubnId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  this.state.females = result.data;
              } else {    
                  this.$showSuccess('errors.Error_fetching_females');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
          const element = document.getElementById(id);
          if (!element || element.tagName !== "SELECT") {
              console.error(`Choices: Invalid or missing select element with ID "${id}".`);
              return;
          }

          // Destroy previous instance if it exists
          if (this[instanceKey]) {
              this[instanceKey].destroy();
          }

          // Initialize new Choices instance
          this[instanceKey] = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true,
          });

          // Set selected value if it exists in list
          if (selectedValue) {
              const optionExists = dataList.some(item => item.id === selectedValue);
              this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
          }
      },      
              
      async updateUBN() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vrulesUBN$.$validate();
            
            if(!this.vrulesUBN$.$error) {
                const response = await axios.put('mating/updateubn', {
                  "groupGuid": this.state.groupGuid,
                  "ubnId": this.state.ubnId,
                  "maleLeased": this.state.maleLeased
                });
                this.gets = response.data;

                if (this.gets.success) {
                  
                  this.$showSuccess('errors.Success_mating_ubn_updated_successfully');
                  
                  this.$router.push({ path: `/mating/edit/${this.state.groupGuid}` }).then(() => {
                    this.fetchMatingData(this.state.groupGuid);
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateMale() {   
        try {
            this.$store.commit('setShowLoading', true);
            this.vrulesMales$.$validate();
            
            if(!this.vrulesMales$.$error) {

              if(this.state.selectedMaleLeasedFromUBNId === '')
              {
                  this.$showSuccess('errors.Mating_male_is_already_updated');
                  return;
              }

              const response = await axios.put('mating/updatemale', {
                "groupGuid": this.state.groupGuid,         
                "arrivalFromUbn": this.state.arrivalFromUbn,
                "maleId": this.state.selectedMaleId,
                "maleLeased": this.state.maleLeased,
                "maleLeasedFromUbnId": this.state.selectedMaleLeasedFromUBNId
              });
              this.gets = response.data;

              if (this.gets.success) {
                this.$showSuccess('errors.Success_mating_male_updated_successfully');
                
                this.$router.push({ path: `/mating/edit/${this.state.groupGuid}` }).then(() => {
                  this.fetchMatingData(this.state.groupGuid); // Trigger data refresh or any required action
                });
              } else {
                this.$showError('errors.Contact_system_admin');
              }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateFemale() {   
        try {
            this.$store.commit('setShowLoading', true);
            this.vrulesFemales$.$validate();
            
            if(!this.vrulesFemales$.$error) {

              const response = await axios.put('mating/updatefemale', {
                "groupGuid": this.state.groupGuid,                         
                "femaleIds": this.state.selectedFemaleIds.join(',')                
              });
              this.gets = response.data;

              if (this.gets.success) {
                this.$showSuccess('errors.Success_mating_male_updated_successfully');
                
                this.$router.push({ path: `/mating/edit/${this.state.groupGuid}` }).then(() => {
                  this.fetchMatingData(this.state.groupGuid); // Trigger data refresh or any required action
                });
              } else {
                this.$showError('errors.Contact_system_admin');
              }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateDate() {   
        try {
            this.$store.commit('setShowLoading', true);            
            
            const valid = await this.vrulesDates$.$validate();
            if (!valid) return;

            const response = await axios.put('mating/updatedate', {
              groupGuid: this.state.groupGuid,
              dateFrom: this.state.dateFrom || null,
              dateTo: this.state.dateTo || null
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_mating_date_updated_successfully');
              
              this.$router.push({ path: `/mating/edit/${this.state.groupGuid}` }).then(() => {
                this.fetchMatingData(this.state.groupGuid); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },      
      deleteMating() {
        if (this.state.deleteMating) {
          this.deleteMating1(this.state.groupGuid)
        }
      },                  
      async deleteMating1(groupGuid) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("mating/group/" + groupGuid);
            this.gets = response.data;

            if (this.gets.success) {

              this.$showSuccess('errors.Success_mating_deleted_successfully');
              
              this.$router.push('/mating');                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {          
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      }
    }
  };
  </script>
  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
</style>